/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import ProductCard from "../../components/ProductCard";
import BreakpointUp from "../../components/Media/BreakpointUp";
import BreakpointDown from "../../components/Media/BreakpointDown";
import ArrowIcon from "../../components/Icons/ArrowIcon";

const SectionGrid = styled.div`
	position: relative;
  display: flex;	
  flex-wrap: wrap;
	margin-left:-15px;
	margin-right:-15px;
`;

const LeftSidebar = styled.div`
  position: relative;
  padding:0 15px;
  width: 100%;
  .sticky-wrapper {
    position: fixed;
    top: 130px;
    width: 100%;
  }
  .no-sticky {
    position: relative;
    top: 0;
  }
  ${BreakpointUp.lg`		
    flex:0 0 16.666667%;
	`}
  @media(max-width: 1023px) {
    .sticky-wrapper {
      position: relative !important;
      top: 0;
    }
  }
`;

const RightContent = styled.div`
  padding:0 15px;
  width: 100%;
  ${BreakpointUp.lg`		
    flex:0 0 83.333333%;
	`}
`;

const TabNav = styled.div`
  width: 100%;
  margin-bottom:30px;
  ${BreakpointDown.lg`	
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    margin:0 auto 30px;
    text-align:center;
  `}
`;

const TabItem = styled.div`
  position: relative;
  display: block;
  padding: 15px 0;
  ${BreakpointDown.lg`
    display:inline-block;
    padding:0 15px;
  `}
  &.active{
    div{
      &:before{
        background-color:#020304;
      }
    }
  }
`;

const TabLink = styled.div`
  color: #666;
  font-weight: 700;
  display: block;
  position: relative;
  line-height: 20px;
  padding: 10px 0;
  ${BreakpointUp.lg`
    padding: 0 0 0 20px;
  `}
  &:before{
    content: '';
    left: 0;
    background-color: transparent;
    display: inline-block;
    position: absolute;
    height: 4px;
    width: 100%;
    top:auto;
    bottom:0;
    ${BreakpointUp.lg`
      height: 100%;
      width: 4px;
      top: 0;
      bottom:auto;
	  `}
  }
  &:hover {
	  color: #020304;
    cursor: pointer;
  }	
`;

const TabContent = styled.div`
  margin:0;
  ${BreakpointUp.sm`
		margin:0 0 0 -40px;
	`}
`;

const TabPane = styled.div`
  ${BreakpointUp.sm`
    padding:0 40px;	
  `}
`;

const RoofProducts = styled.div`
  max-width: 1124px;
  width: 100%;
  margin: auto;
`;

const ExploreMore = styled.div`
  display:block;
  text-align:center;
  margin:30px 0;
`;

const LinkButton = styled.span`
  display:inline-block;
  color:#020304;
  font-weight:700;
  position:relative;
  line-height:30px;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    height: 2px;
    transition: -webkit-transform .4s cubic-bezier(.77,0,.175,1);
    transition: transform .4s cubic-bezier(.77,0,.175,1);
    transition: transform .4s cubic-bezier(.77,0,.175,1),-webkit-transform .4s cubic-bezier(.77,0,.175,1);
    transform: translateZ(0) scaleX(1);
    background: #020304;
    transform-origin: right center;
    transform: translateZ(0) scaleX(0);
  }
  & svg {
    transition: transform 0.3s ease-out;
  }
  &:hover{
    &:after {
      transform-origin: left center;
      transform: translateZ(0) scaleX(1);
    }    
    color:#020304;
    svg {
      fill:#020304;
      transform: translateX(4px);
    }
  }
	span {
    display:inline-block;
    vertical-align: middle;
    line-height:20px;
    + svg{
      margin-left:10px;
    }
  }
	svg{
    display:inline-block;
    vertical-align: middle;
  }
`;

const ProductCardList = ({ data, limit = "all", showQuote, scrollTarget, buttonLink, buttonTxt, roof }) => {
  const [state, setState] = React.useState({
    currentTab: "all",
    tabProducts: [],
    roofProducts: [],
  });

  React.useEffect(() => {
    setState({
      ...state,
      limit,
      tabProducts: data,
      roofProducts: limit === "all" ? data : data.slice(0, limit)
    });
  }, []);

  const handleTabClick = (tab) => {
    const tabProductsFilteredByTab = tab === "all" ? data : data.filter(d => d.node.productRoof.roofName === tab);
    const tabProductsFilteredByLimit = limit === "all" ? tabProductsFilteredByTab : tabProductsFilteredByTab.slice(0, limit);
    setState({
      ...state,
      currentTab: tab,
      tabProducts: tabProductsFilteredByLimit
    });
    if (scrollTarget) {
      setTimeout(() => {
        const element = document.getElementById(scrollTarget);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }, 100);
    }
  };

  return (
    <div>
      {roof ? (
        <RoofProducts>
          <TabContent>
            <TabPane>
              {state.roofProducts.map((item, i) =>
                <ProductCard key={i} data={item.node} showQuote={showQuote} />
              )}
            </TabPane>
            {buttonLink && buttonTxt && limit !== "all" &&
              <ExploreMore>
                <Link to={buttonLink}>
                  <LinkButton>
                    <span>{buttonTxt}</span><ArrowIcon />
                  </LinkButton>
                </Link>
              </ExploreMore>
            }
          </TabContent>
        </RoofProducts>
      ) : (
        <SectionGrid>
          <LeftSidebar>
            <TabNav className="isSticky" >
              <TabItem className={state.currentTab === "all" ? "active" : ""}>
                <TabLink onClick={() => handleTabClick("all")} >All Products</TabLink>
              </TabItem>
              <TabItem className={state.currentTab === "Vertical Roof" ? "active" : ""}>
                <TabLink onClick={() => handleTabClick("Vertical Roof")}>Vertical Roof</TabLink>
              </TabItem>
              <TabItem className={state.currentTab === "A-Frame Roof" ? "active" : ""}>
                <TabLink onClick={() => handleTabClick("A-Frame Roof")}>A-Frame Roof</TabLink>
              </TabItem>
              <TabItem className={state.currentTab === "Regular Roof" ? "active" : ""}>
                <TabLink onClick={() => handleTabClick("Regular Roof")}>Regular Roof</TabLink>
              </TabItem>
            </TabNav>
          </LeftSidebar>
          <RightContent>
            <TabContent>
              <TabPane>
                {state.tabProducts.map((item, i) =>
                  <ProductCard key={i} data={item.node} showQuote={showQuote} />
                )}
              </TabPane>
              {buttonLink && buttonTxt && limit !== "all" &&
                <ExploreMore>
                  <Link to={buttonLink}>
                    <LinkButton>
                      <span>{buttonTxt}</span><ArrowIcon />
                    </LinkButton>
                  </Link>
                </ExploreMore>
              }
            </TabContent>
          </RightContent>
        </SectionGrid>
      )}
    </div>
  );
}


export default ProductCardList